// extracted by mini-css-extract-plugin
export default {"grid":"CandleValidationsPage_grid__SfDJH","toolbar":"CandleValidationsPage_toolbar__HJlv6","flex":"CandleValidationsPage_flex__JzA9E"};